import { Flame, BarChart3, CalendarDays } from "lucide-react";
import DataFetcherTemplateHome from "../hooks/DataFetcherTemplateHome";
import SportsTabs from "../componentes/SportsTabs";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/8904dc89-8f79-4fcd-9a06-a95aa94156d6" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15,field_bloque16,field_bloque17,field_bloque18," +
  "field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function CalendarContainer({ htmlContent }) {
  if (!htmlContent)
    return (
      <div className="text-center p-4 text-neutral-400 text-sm">
        No hay datos disponibles
      </div>
    );

  return (
    <div className="w-full overflow-x-auto rounded-2xl shadow-xl border border-neutral-100 dark:border-neutral-800/70 bg-white dark:bg-neutral-900">
      <div
        className="
          min-w-[550px] md:min-w-full p-4 sm:p-5
          
          /* ==========================================================================
             TÍTULOS PRINCIPALES H2 (Si vienen dentro del bloque)
             ========================================================================== */
          [&_h2]:text-lg [&_h2]:md:text-xl [&_h2]:font-black [&_h2]:text-[#004270] [&_h2]:dark:text-amber-400 [&_h2]:text-center [&_h2]:tracking-tight [&_h2]:mb-5 [&_h2]:mt-2 [&_h2]:uppercase

          /* ==========================================================================
             H3 - ENCABEZADOS DE JORNADAS/FECHAS (Estilo Premium)
             ========================================================================== */
          [&_h3]:text-xs [&_h3]:sm:text-sm [&_h3]:font-extrabold 
          [&_h3]:text-white [&_h3]:bg-[#004270] [&_h3]:dark:bg-neutral-800 
          [&_h3]:border-b-2 [&_h3]:border-amber-400 [&_h3]:dark:border-amber-500
          [&_h3]:py-2.5 [&_h3]:px-4 [&_h3]:rounded-t-xl [&_h3]:text-left 
          [&_h3]:uppercase [&_h3]:tracking-wider [&_h3]:mb-0 [&_h3]:mt-6

          /* ==========================================================================
             H4 - BADGES / ETIQUETAS (Ej: 'Fase de Grupos')
             ========================================================================== */
          [&_h4]:inline-block [&_h4]:mx-auto [&_h4]:w-auto [&_h4]:text-[10px] [&_h4]:font-bold [&_h4]:uppercase [&_h4]:tracking-widest [&_h4]:bg-amber-100 [&_h4]:dark:bg-neutral-800 [&_h4]:text-amber-800 [&_h4]:dark:text-amber-400 [&_h4]:border [&_h4]:border-amber-200/50 [&_h4]:dark:border-neutral-700 [&_h4]:px-2.5 [&_h4]:py-0.5 [&_h4]:rounded-full [&_h4]:mb-3 [&_h4]:text-center [&_h4]:flex [&_h4]:justify-center [&_h4]:max-w-max

          /* ==========================================================================
             ESTRUCTURA GENERAL DE LA TABLA
             ========================================================================== */
          [&_table]:w-full [&_table]:mb-6 [&_table]:border-collapse 
          [&_table]:text-[11px] [&_table]:sm:text-xs 
          [&_table]:overflow-hidden [&_table]:rounded-b-xl [&_table]:border 
          [&_table]:border-t-0 [&_table]:border-neutral-200 [&_table]:dark:border-neutral-800

          /* ==========================================================================
             ENCABEZADOS DE COLUMNA (TH)
             ========================================================================== */
          [&_th]:bg-neutral-50 [&_th]:dark:bg-neutral-900/60 
          [&_th]:text-neutral-500 [&_th]:dark:text-neutral-400 
          [&_th]:font-bold [&_th]:uppercase [&_th]:tracking-wider 
          [&_th]:py-2 [&_th]:sm:py-2.5 [&_th]:px-3 
          [&_th]:border-b [&_th]:border-neutral-200 [&_th]:dark:border-neutral-700 [&_th]:text-center

          /* ==========================================================================
             FILAS (TR) Y ALTERNACIÓN DE COLORES (Zebra Striping)
             ========================================================================== */
          [&_tr]:transition-colors [&_tr]:duration-150
          [&_tr:nth-child(even)]:bg-neutral-50/60 [&_tr:nth-child(even)]:dark:bg-neutral-800/30
          [&_tr:hover]:bg-amber-50/40 [&_tr:hover]:dark:bg-amber-500/5

          /* ==========================================================================
             CELDAS (TD)
             ========================================================================== */
          [&_td]:py-2 [&_td]:sm:py-2.5 [&_td]:px-3 
          [&_td]:border-b [&_td]:border-neutral-100 [&_td]:dark:border-neutral-800/40 
          [&_td]:text-neutral-600 [&_td]:dark:text-neutral-300 
          [&_td]:text-center [&_td]:align-middle

          /* ==========================================================================
             DESTACAR COLUMNA CENTRAL (Encuentros / Partidos)
             ========================================================================== */
          [&_td:nth-child(3)]:font-semibold [&_td:nth-child(3)]:text-neutral-900 [&_td:nth-child(3)]:dark:text-white
        "
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </div>
  );
}

function ScorersContainer({ htmlContent }) {
  if (!htmlContent)
    return (
      <div className="text-center p-4 text-neutral-400 text-sm">
        No hay datos de goleadores disponibles
      </div>
    );

  return (
    <div className="w-full overflow-x-auto rounded-2xl shadow-xl border border-neutral-100 dark:border-neutral-800/70 bg-white dark:bg-neutral-900">
      <div
        className="
          min-w-[500px] md:min-w-full p-3 sm:p-4
          
          /* ==========================================================================
             H3 - ENCABEZADOS DE LA TABLA DE GOLEADORES (Diferenciado: Estilo Fuego/Goles)
             ========================================================================== */
          [&_h3]:text-[11px] [&_h3]:sm:text-xs [&_h3]:font-black 
          [&_h3]:text-white [&_h3]:bg-gradient-to-r [&_h3]:from-red-600 [&_h3]:to-orange-500 [&_h3]:dark:from-red-900 [&_h3]:dark:to-neutral-800
          [&_h3]:border-b-2 [&_h3]:border-amber-400
          [&_h3]:py-1.5 [&_h3]:px-3 [&_h3]:rounded-t-xl [&_h3]:text-left 
          [&_h3]:uppercase [&_h3]:tracking-widest [&_h3]:mb-0 [&_h3]:mt-4

          /* ==========================================================================
             ESTRUCTURA COMPACTA DE LA TABLA
             ========================================================================== */
          [&_table]:w-full [&_table]:mb-4 [&_table]:border-collapse 
          /* Letra reducida a 10px en móvil y 11px en pantallas mayores */
          [&_table]:text-[10px] [&_table]:sm:text-[11px] 
          [&_table]:overflow-hidden [&_table]:rounded-b-xl [&_table]:border 
          [&_table]:border-t-0 [&_table]:border-neutral-200 [&_table]:dark:border-neutral-800

          /* ==========================================================================
             ENCABEZADOS DE COLUMNA (TH)
             ========================================================================== */
          [&_th]:bg-neutral-100 [&_th]:dark:bg-neutral-950
          [&_th]:text-neutral-500 [&_th]:dark:text-neutral-400 
          [&_th]:font-bold [&_th]:uppercase [&_th]:tracking-tight
          /* Reducción drástica de padding vertical */
          [&_th]:py-1.5 [&_th]:px-0 
          [&_th]:border-b [&_th]:border-neutral-200 [&_th]:dark:border-neutral-700 [&_th]:text-center

          /* ==========================================================================
             FILAS (TR) Y CEBRA SUTIL
             ========================================================================== */
          [&_tr]:transition-colors [&_tr]:duration-150
          [&_tr:nth-child(even)]:bg-neutral-50/40 [&_tr:nth-child(even)]:dark:bg-neutral-800/20
          [&_tr:hover]:bg-red-50/30 [&_tr:hover]:dark:bg-red-500/5

          /* ==========================================================================
             CELDAS COMPACTAS (TD)
             ========================================================================== */
          /* Espaciado mínimo (py-1.5) para que entren más filas en pantalla */
          [&_td]:py-0 [&_td]:px-1
          [&_td]:border-b [&_td]:border-neutral-100 [&_td]:dark:border-neutral-800/40 
          [&_td]:text-neutral-600 [&_td]:dark:text-neutral-400 
          [&_td]:text-left [&_td]:align-middle

          /* ==========================================================================
             REGLAS DE IDENTIDAD PARA LAS COLUMNAS DE GOLEADORES
             ========================================================================== */
          /* Columna 2 (Nombre del Jugador) suele ser alineada a la izquierda y más oscura */
          [&_td:nth-child(2)]:text-left [&_td:nth-child(2)]:font-medium [&_td:nth-child(2)]:text-neutral-900 [&_td:nth-child(2)]:dark:text-neutral-200
          
          /* Última columna (Goles) en negrita expansiva y color destacado */
          [&_td:last-child]:font-black [&_td:last-child]:text-red-600 [&_td:last-child]:dark:text-amber-400 [&_td:last-child]:text-sm
        "
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </div>
  );
}

// COMPONENTE DE TÍTULO MEJORADO CON ÍCONO
const SectionTitle = ({ children, icon: Icon }) => (
  <div className="flex flex-col items-center justify-center gap-2 mb-8">
    <div className="flex items-center justify-center w-12 h-12 rounded-2xl bg-[#004270]/5 dark:bg-amber-400/10 text-[#004270] dark:text-amber-400 shadow-inner">
      <Icon className="w-6 h-6" />
    </div>
    <h2 className="text-2xl sm:text-3xl text-[#004270] dark:text-white font-black uppercase tracking-tight text-center">
      {children}
    </h2>
    <div className="w-12 h-1 bg-[#febe10] rounded-full mt-1" />
  </div>
);

function SportFest() {
  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => {
        return (
          <div className="w-full bg-white dark:bg-neutral-950 min-h-screen scroll-smooth text-neutral-800 dark:text-neutral-200">
            {/* HERO BANNER */}
            <section className="relative overflow-hidden bg-gradient-to-br from-[#021024] via-[#004270] to-[#040b19] py-16 lg:py-20 border-b border-[#004270]/20 text-white shadow-lg">
              <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#febe10_1px,transparent_1px)] [background-size:16px_16px] pointer-events-none" />
              <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#febe10]/10 rounded-full blur-3xl pointer-events-none" />
              <div className="absolute bottom-0 left-10 w-80 h-80 bg-[#004270]/50 rounded-full blur-3xl pointer-events-none" />

              <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
                <div className="text-left max-w-xl">
                  <div className="inline-flex items-center gap-2 bg-[#febe10] text-[#004270] font-bold text-xs uppercase px-3 py-1.5 rounded-full shadow-sm mb-4">
                    <Flame className="w-3.5 h-3.5 animate-pulse" />
                    <span>UTPL SportFest 2026</span>
                  </div>
                  <h1 className="text-4xl sm:text-5xl font-black tracking-tight leading-none mb-3">
                    Cronograma & <br />
                    <span className="text-[#febe10]">Resultados Oficiales</span>
                  </h1>
                  <p className="text-slate-200 text-sm sm:text-base leading-relaxed">
                    Mantente al tanto del calendario oficial, los partidos
                    interactivos de Baloncesto y Fútbol Sala, y conoce a los
                    campeones que conquistan el podio.
                  </p>
                </div>

                {/* SVG Logo */}
                <div className="relative w-64 h-64 flex items-center justify-center bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 p-6 shadow-2xl">
                  <svg
                    viewBox="0 0 120 120"
                    className="w-full h-full text-white"
                  >
                    <circle
                      cx="60"
                      cy="60"
                      r="50"
                      fill="none"
                      stroke="rgba(254, 190, 16, 0.2)"
                      strokeWidth="1"
                      strokeDasharray="4 2"
                    />
                    <path
                      d="M60,20 C68,40 85,45 80,65 C75,80 60,95 60,95 C60,95 45,80 40,65 C35,45 52,40 60,20 Z"
                      fill="url(#sportfestGradient)"
                    />
                    <text
                      x="60"
                      y="105"
                      textAnchor="middle"
                      fill="#febe10"
                      fontSize="8"
                      fontWeight="bold"
                      letterSpacing="1"
                    >
                      SPORTFEST
                    </text>
                    <text
                      x="60"
                      y="113"
                      textAnchor="middle"
                      fill="#FFFFFF"
                      fontSize="6"
                      fontWeight="bold"
                      opacity="0.8"
                    >
                      UTPL 2026
                    </text>
                    <defs>
                      <linearGradient
                        id="sportfestGradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor="#febe10" />
                        <stop offset="50%" stopColor="#ff7b00" />
                        <stop offset="100%" stopColor="#004270" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </section>

            {/* BLOQUE DE BOTONES ANCLA */}
            <section className="max-w-5xl mx-auto px-4 -mt-6 relative z-20">
              <div className="bg-white dark:bg-neutral-900 rounded-2xl shadow-xl border border-neutral-100 dark:border-neutral-800 p-4 sm:p-6 flex flex-col sm:flex-row justify-center items-center gap-4">
                <span className="text-xs font-bold text-neutral-400 uppercase tracking-wider sm:mr-2">
                  Ir directo a:
                </span>

                <a
                  href="#tablaposiciones"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#004270] hover:bg-[#003358] text-white text-sm font-bold px-5 py-3 rounded-xl transition-all duration-200 transform hover:-translate-y-0.5 shadow-md shadow-[#004270]/10"
                >
                  <BarChart3 className="w-4 h-4 text-amber-400" />
                  Tabla de Posiciones
                </a>

                <a
                  href="#proximospartidos"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 text-[#004270] dark:text-amber-400 text-sm font-bold px-5 py-3 rounded-xl transition-all duration-200 transform hover:-translate-y-0.5 border border-neutral-200/50 dark:border-neutral-700"
                >
                  <CalendarDays className="w-4 h-4 text-[#004270] dark:text-amber-400" />
                  Próximos Partidos
                </a>
              </div>
            </section>

            {/* SECCIÓN 1: INFORMATIVO + TABLA DE POSICIONES (Fondo Grisáceo Suave) */}
            <section
              id="tablaposiciones"
              className="bg-neutral-50/60 dark:bg-neutral-900/40 border-b border-neutral-100 dark:border-neutral-900 pt-12 pb-20 scroll-mt-16"
            >
              <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionTitle icon={BarChart3}>
                  Tabla de posiciones
                </SectionTitle>

                <SportsTabs
                  idGroup="posiciones"
                  futbolsala={
                    <div className="flex flex-col lg:flex-row gap-6 w-full">
                      <div className="lg:flex-[7] min-w-0">
                        <CalendarContainer htmlContent={data.bloque9} />
                      </div>

                      <div className="lg:flex-[3] min-w-0">
                        <ScorersContainer htmlContent={data.bloque10} />
                      </div>
                    </div>
                  }
                  baloncesto={
                    <div className="flex flex-col lg:flex-row gap-6 w-full">
                      <div className="lg:flex-[7] min-w-0">
                        <CalendarContainer htmlContent={data.bloque11} />
                      </div>

                      <div className="lg:flex-[3] min-w-0">
                        <ScorersContainer htmlContent={data.bloque12} />
                      </div>
                    </div>
                  }
                  medallero={
                    <div className=" w-full">
                      <div>
                        <CalendarContainer htmlContent={data.bloque13} />
                      </div>

                      <div>
                        <ScorersContainer htmlContent={data.bloque14} />
                      </div>
                    </div>
                  }
                  baloncestofemenino={
                    <div className="flex flex-col lg:flex-row gap-6 w-full">
                      <div className="lg:flex-[7] min-w-0">
                        <CalendarContainer htmlContent={data.bloque15} />
                      </div>

                      <div className="lg:flex-[3] min-w-0">
                        <ScorersContainer htmlContent={data.bloque16} />
                      </div>
                    </div>
                  }
                  futbol9={
                    <div className="flex flex-col lg:flex-row gap-6 w-full">
                      <div className="lg:flex-[7] min-w-0">
                        <CalendarContainer htmlContent={data.bloque19} />
                      </div>

                      <div className="lg:flex-[3] min-w-0">
                        <ScorersContainer htmlContent={data.bloque20} />
                      </div>
                    </div>
                  }
                  ecuavoley={
                    <div className="flex flex-col lg:flex-row gap-6 w-full">
                      <div className="lg:flex-[7] min-w-0">
                        <CalendarContainer htmlContent={data.bloque21} />
                      </div>

                      <div className="lg:flex-[3] min-w-0">
                        <ScorersContainer htmlContent={data.bloque22} />
                      </div>
                    </div>
                  }
                  duatlon={
                    <>
                      <div>
                        <div>
                          <CalendarContainer htmlContent={data.bloque24} />
                        </div>
                      </div>
                    </>
                  }

                       natacion={
                    <>
                      <div>
                        <div>
                          <CalendarContainer htmlContent={data.bloque23} />
                        </div>
                      </div>
                    </>
                  }

                       hyrox={
                    <>
                      <div>
                        <div>
                          <CalendarContainer htmlContent={data.bloque25} />
                        </div>
                      </div>
                    </>
                  }
                />
              </div>
            </section>

            {/* SECCIÓN 2: PRÓXIMOS PARTIDOS (Fondo Blanco Limpio para contrastar) */}
            <section
              id="proximospartidos"
              className="bg-white dark:bg-neutral-950 py-20 scroll-mt-16"
            >
              <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionTitle icon={CalendarDays}>
                  Próximos partidos
                </SectionTitle>

                <SportsTabs
                  idGroup="partidos"
                  futbol9={<CalendarContainer htmlContent={data.bloque18} />}
                  ecuavoley={<CalendarContainer htmlContent={data.bloque17} />}
                  futbolsala={<CalendarContainer htmlContent={data.bloque2} />}
                  baloncesto={<CalendarContainer htmlContent={data.bloque3} />}
                  tenis={<CalendarContainer htmlContent={data.bloque4} />}
                  ajedrez={<CalendarContainer htmlContent={data.bloque5} />}
                  futbolin={<CalendarContainer htmlContent={data.bloque6} />}
                  baloncestofemenino={
                    <CalendarContainer htmlContent={data.bloque7} />
                  }
                  atletismo={<CalendarContainer htmlContent={data.bloque8} />}
                />
              </div>
            </section>
          </div>
        );
      }}
    </DataFetcherTemplateHome>
  );
}

export default SportFest;
